import { useMemo, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";

// options: [{ value, group, hint }]
export function SearchPick({ value, onChange, options, placeholder = "Select…", testid, className, note }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const groups = useMemo(() => {
    const s = q.trim().toLowerCase();
    const hit = s ? options.filter((o) => o.value.toLowerCase().includes(s)) : options;
    const ranked = s ? [...hit].sort((a, b) => a.value.toLowerCase().indexOf(s) - b.value.toLowerCase().indexOf(s)) : hit;
    const g = {};
    ranked.slice(0, 200).forEach((o) => { (g[o.group || ""] = g[o.group || ""] || []).push(o); });
    return Object.entries(g);
  }, [options, q]);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className={cn("flex min-h-[2.25rem] w-full items-center justify-between gap-2 rounded-md border border-[#E2E8F0] bg-white px-2 py-1 text-left dark:border-[#223139] dark:bg-white/5 dark:text-white", className)}>
          <span className={cn("whitespace-normal break-words", !value && "text-[#8B9698]")}>{value || placeholder}</span>
          <ChevronsUpDown className="h-4 w-4 shrink-0 text-[#8B9698]" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[min(92vw,380px)] p-0" align="start">
        <Command shouldFilter={false}>
          <CommandInput value={q} onValueChange={setQ} placeholder="Type to search…" data-testid={testid ? `${testid}-search` : undefined} />
          <CommandList className="max-h-72">
            <CommandEmpty>No match.</CommandEmpty>
            {groups.map(([g, list]) => (
              <CommandGroup key={g} heading={g}>
                {list.map((o) => (
                  <CommandItem key={`${g}-${o.value}`} value={`${o.value} ${o.hint || ""} ${g}`} onSelect={() => { onChange(o.value, o); setOpen(false); }} data-testid={testid ? `${testid}-opt-${o.value}` : undefined}>
                    <div className="min-w-0"><div className="whitespace-normal">{o.value}</div>{o.hint && <div className="whitespace-normal text-xs text-[#8B9698]">{o.hint}</div>}</div>
                  </CommandItem>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
          {note && <p className="border-t border-[#E2E8F0] px-3 py-2 text-xs text-amber-700 dark:border-[#223139]">{note}</p>}
        </Command>
      </PopoverContent>
    </Popover>
  );
}
